import script from "./RepaymentContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentContent.vue?vue&type=script&setup=true&lang=ts"

import "./RepaymentContent.vue?vue&type=style&index=0&id=7163fdd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7163fdd4"]])

export default __exports__